import { ActionableMessageCardInItemViewState } from 'owa-mail-reading-pane-store';
import { mutatorAction } from 'satcheljs/';
import { trace } from 'owa-trace';

const setShowBodyWithMessageCard = mutatorAction(
    'SET_SHOW_BODY_WITH_MESSAGE_CARD',
    function setShowBodyWithMessageCard(
        viewState: ActionableMessageCardInItemViewState,
        showBodyWithMessageCard: boolean
    ) {
        if (viewState) {
            viewState.showBodyWithMessageCard = showBodyWithMessageCard;
        } else {
            trace.warn('[ActionableMessageDebug] setShowBodyWithMessageCard: viewState undefined');
        }
    }
);

export default setShowBodyWithMessageCard;
